import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';

import AdminGymPageHeader from './components/AdminGymPageHeader';
import AdminGymTableContainer from './components/AdminGymTableContainer';

const AdminGymPage = (): JSX.Element => {
  const [search, setSearch] = useState<string>('');
  const [debouncedSearch] = useDebouncedValue<string>(search, 250);

  return (
    <>
      <AdminGymPageHeader search={search} setSearch={setSearch} />
      <AdminGymTableContainer search={debouncedSearch} />
    </>
  );
};

export default AdminGymPage;
